<template>
    <div class="mileage-detail">
        <p class="mileage-detail-header">里程明细( 装货补贴里程计算方式：{{ calculation }} )
            <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content" v-html="DCTooltip('CALCULATION_TYPE_REMARK')"></div>
                <i class="el-icon-question"></i>
            </el-tooltip>
        </p>
        <el-table
            :data="mileageDetailData"
            :span-method="arraySpanMethod"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="{'text-align':'center'}"
            @cell-dblclick="cellDblClick"
            border
            class="load-list"
            style="width: 100%" >
            <el-table-column prop="fourAddress" label="四级地址" min-width="200px" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="warehouse" label="仓库" min-width="210px">
                <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.warehouseNameList" :key="index" style="text-align:center">
                        <el-tooltip :content="item" placement="top">
                            <p class="content">{{ item }}</p>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="siteAddress" label="站点地址" min-width="220px">
                <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.lichengRecordDetails" :key="index" style="text-align:center">
                        <el-tooltip :content="item.detailAddr" placement="top">
                            <p class="content">{{ item.detailAddr }}</p>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="operateTypeName" label="类型" min-width="120px"></el-table-column>
            <el-table-column prop="loadSubsidyMileage" min-width="150px">
                <template slot="header">
                    <span>装货补贴里程(km)</span>
                    <el-tooltip class="item" effect="dark" placement="top">
                        <div slot="content" v-html="DCTooltip('LOAD_SUBSIDY_MILEAGE_REMARK')"></div>
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="unloadSubsidyMileage"  min-width="150px" align="center">
                <template slot="header">
                    <span>卸货补贴里程(km)</span>
                    <el-tooltip class="item" effect="dark" placement="top">
                        <div slot="content" v-html="DCTooltip('UNLOAD_SUBSIDY_MILEAGE_REMARK')"></div>
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="subsidyMileage" min-width="150px">
                <template slot="header">
                    <span>串点里程(km)</span>
                    <el-tooltip class="item" effect="dark" placement="top">
                        <div slot="content" v-html="DCTooltip('SUBSIDY_MILEAGE_REMARK')"></div>
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { copyToClip } from '../util.js';
import { dictWithUrl } from '@/components/lots/api.js';
export default {
    name: 'MileageDetail',
    props: {
        calculationType: {
            type: Number
        },
        mileageDetailData: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            dictData: {}
        };
    },
    computed: {
        calculation () {
            return this.calculationType === 1 ? '按装货逻辑仓点数计算' : '按装货四级地址之间的里程总和计算';
        }
    },
    async mounted () {
        await this.getDicData();
    },
    methods: {
        async getDicData () {
            const dict = await dictWithUrl(
                // eslint-disable-next-line max-len
                'CALCULATION_TYPE_REMARK,LOAD_SUBSIDY_MILEAGE_REMARK,UNLOAD_SUBSIDY_MILEAGE_REMARK,SUBSIDY_MILEAGE_REMARK');
            this.dictData = dict.data;
        },
        // 合并单元格
        arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
            // 里程按装货逻辑仓点数计算时(calculationType=1)，装货类型的装货补贴里程合并单元格，此时各单元格数据相同，只显示第一条数据即可
            const loadNum = this.mileageDetailData.filter(v => v.operateType === 'load').length;
            if (this.calculationType === 1) {
                if (rowIndex === 0 && columnIndex === 4) {
                    return [loadNum, 1];
                } else if (rowIndex < loadNum && columnIndex === 4) {
                    return [0, 0];
                } else {
                    return [1, 1];
                }
            }
        },
        DCTooltip (optionNum) {
            if (this.dictData[optionNum] && Object.values(this.dictData[optionNum]).length) {
                return Object.values(this.dictData[optionNum]).join('<br/>');
            }
            return '';
        },
        /**
         * @description 双击复制单元格信息
         */
        cellDblClick (row, column, cell, event) {
            if (row[column.property] === null || row[column.property] === undefined) return;
            const value = row[column.property];
            copyToClip(value);
        }
    }

};
</script>

<style lang="less" scoped>
.mileage-detail {
    margin-bottom: 10px;
    background-color: #fff;
}
.mileage-detail-header {
    margin-top: 0px;
    padding-top: 10px;
    font-size: 13px;
}
.el-icon-question {
    margin-left: 3px;
    font-size: 16px;
    color: #00bcbf;
    background-color: #ebeef5;
}
.content {
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
}
</style>
